import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "cls_detail" }
const _hoisted_2 = { class: "video" }
const _hoisted_3 = { class: "cls-main" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "title flex-start" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("span", null, "教室信息")
], -1)
const _hoisted_5 = { class: "flex-start info-cont" }
const _hoisted_6 = {
  key: 0,
  class: "base-info"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "IP：", -1)
const _hoisted_8 = {
  key: 1,
  class: "base-info"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "视角：", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "base-info"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "校区：", -1)
const _hoisted_14 = {
  key: 3,
  class: "base-info"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "教学楼：", -1)
const _hoisted_16 = { class: "base-info" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "教室：", -1)
const _hoisted_18 = { class: "change_source" }
const _hoisted_19 = {
  key: 0,
  class: "title flex-start"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "切换播放源", -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "content flex" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "title flex-start"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "环境参数", -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "content cls_infos"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-wenduji",
  style: {"color":"rgb(206, 93, 98)"}
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-shidu",
  style: {"color":"#409eff"}
}, null, -1)
const _hoisted_32 = {
  key: 2,
  class: "title flex-start"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "物联网管控", -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 3,
  class: "content internet"
}
const _hoisted_37 = { class: "icon" }
const _hoisted_38 = { class: "name" }
const _hoisted_39 = { class: "icon" }
const _hoisted_40 = { class: "name" }
const _hoisted_41 = { class: "icon" }
const _hoisted_42 = { class: "name" }
const _hoisted_43 = { class: "icon" }
const _hoisted_44 = { class: "name" }
const _hoisted_45 = { class: "icon" }
const _hoisted_46 = { class: "name" }
const _hoisted_47 = { class: "icon" }
const _hoisted_48 = { class: "name" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "title flex-start" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("span", null, "终端管控")
], -1)
const _hoisted_50 = { class: "content terminal" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-shangke" })
], -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "上课", -1)
const _hoisted_53 = [
  _hoisted_51,
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-xiakedianji" })
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "下课", -1)
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-menjin" })
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "门禁", -1)
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-menjin" })
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "面板锁", -1)
const _hoisted_62 = [
  _hoisted_60,
  _hoisted_61
]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jiangtai" })
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "讲台锁", -1)
const _hoisted_65 = [
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-warning" })
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "中控报警", -1)
const _hoisted_68 = [
  _hoisted_66,
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-touyingyi" })
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "投影仪一", -1)
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-touyingyi" })
], -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "name" }, "投影仪二", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = { class: "btn-bot flex-center" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", null, "更多设置", -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = { class: "terminalMoreMenu" }
const _hoisted_79 = { class: "more_menu_title" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", null, "终端管控", -1)
const _hoisted_81 = {
  key: 0,
  class: "more_menu_content"
}
const _hoisted_82 = { class: "category" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "一键控制", -1)
const _hoisted_84 = { class: "category_content" }
const _hoisted_85 = { class: "category" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "开关控制", -1)
const _hoisted_87 = { class: "category_content" }
const _hoisted_88 = { class: "category" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "投影仪", -1)
const _hoisted_90 = { class: "category_content" }
const _hoisted_91 = { class: "category" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "视频输入", -1)
const _hoisted_93 = { class: "category_content" }
const _hoisted_94 = {
  key: 0,
  class: "category"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "电源箱", -1)
const _hoisted_96 = { class: "category_content" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = {
  key: 1,
  class: "more_menu_content"
}
const _hoisted_99 = { class: "category" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "一键控制", -1)
const _hoisted_101 = { class: "category_content" }
const _hoisted_102 = { class: "category" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "开关控制", -1)
const _hoisted_104 = { class: "category_content" }
const _hoisted_105 = { class: "category" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "投影仪", -1)
const _hoisted_107 = { class: "category_content" }
const _hoisted_108 = { class: "category" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "视频输入", -1)
const _hoisted_110 = { class: "category_content" }
const _hoisted_111 = { class: "category" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "视频输出", -1)
const _hoisted_113 = { class: "category_content" }
const _hoisted_114 = {
  key: 0,
  class: "category"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "电源箱", -1)
const _hoisted_116 = { class: "category_content" }
const _hoisted_117 = ["onClick"]
const _hoisted_118 = {
  key: 2,
  class: "more_menu_content"
}
const _hoisted_119 = { class: "category" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "一键控制", -1)
const _hoisted_121 = { class: "category_content" }
const _hoisted_122 = { class: "category" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "开关控制", -1)
const _hoisted_124 = { class: "category_content" }
const _hoisted_125 = { class: "category" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "投影仪", -1)
const _hoisted_127 = { class: "category_content" }
const _hoisted_128 = {
  key: 0,
  class: "category"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "电源箱", -1)
const _hoisted_130 = { class: "category_content" }
const _hoisted_131 = ["onClick"]
const _hoisted_132 = {
  key: 3,
  class: "more_menu_content"
}
const _hoisted_133 = { class: "category" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "一键控制", -1)
const _hoisted_135 = { class: "category_content" }
const _hoisted_136 = { class: "category" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "开关控制", -1)
const _hoisted_138 = { class: "category_content" }
const _hoisted_139 = { class: "category" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "投影仪", -1)
const _hoisted_141 = { class: "category_content" }
const _hoisted_142 = { class: "category" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "投影机显示", -1)
const _hoisted_144 = { class: "category_content" }
const _hoisted_145 = { class: "category" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "音视频输出", -1)
const _hoisted_147 = { class: "category_content" }
const _hoisted_148 = { class: "category" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "幕布控制", -1)
const _hoisted_150 = { class: "category_content" }
const _hoisted_151 = {
  key: 4,
  class: "more_menu_content"
}
const _hoisted_152 = { class: "category" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "一键控制", -1)
const _hoisted_154 = { class: "category_content" }
const _hoisted_155 = { class: "category" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "锁控制", -1)
const _hoisted_157 = { class: "category_content" }
const _hoisted_158 = { class: "category" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "电脑控制", -1)
const _hoisted_160 = { class: "category_content" }
const _hoisted_161 = { class: "category" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "视频通道", -1)
const _hoisted_163 = { class: "category_content" }
const _hoisted_164 = { class: "category" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "投影仪", -1)
const _hoisted_166 = { class: "category_content" }
const _hoisted_167 = { class: "category" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "幕布控制", -1)
const _hoisted_169 = { class: "category_content" }
const _hoisted_170 = { class: "category" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "音量控制", -1)
const _hoisted_172 = { class: "category_content" }
const _hoisted_173 = {
  key: 5,
  class: "more_menu_content"
}
const _hoisted_174 = { class: "category" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", { class: "category_title" }, "一键控制", -1)
const _hoisted_176 = { class: "category_content" }
const _hoisted_177 = { class: "internetMoreMenu" }
const _hoisted_178 = { class: "more_menu_title" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", null, "物联网管控", -1)
const _hoisted_180 = { class: "icon" }
const _hoisted_181 = {
  key: 0,
  class: "more_menu_content"
}
const _hoisted_182 = {
  key: 0,
  class: "internet_item"
}
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-duanluqi" })
], -1)
const _hoisted_184 = { class: "name" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("div", null, "断路器", -1)
const _hoisted_186 = {
  key: 1,
  class: "internet_item"
}
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-dengguang" })
], -1)
const _hoisted_188 = { class: "name" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", null, "灯光", -1)
const _hoisted_190 = {
  key: 2,
  class: "internet_item"
}
const _hoisted_191 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-kaiguan" })
], -1)
const _hoisted_192 = { class: "name" }
const _hoisted_193 = /*#__PURE__*/_createElementVNode("div", null, "调光器", -1)
const _hoisted_194 = {
  key: 3,
  class: "internet_item"
}
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-kongtiao" })
], -1)
const _hoisted_196 = { class: "name" }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("div", null, "空调", -1)
const _hoisted_198 = {
  key: 4,
  class: "internet_item"
}
const _hoisted_199 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fengshan" })
], -1)
const _hoisted_200 = { class: "name" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("div", null, "风扇", -1)
const _hoisted_202 = {
  key: 5,
  class: "internet_item"
}
const _hoisted_203 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-chuanglian" })
], -1)
const _hoisted_204 = { class: "name" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", null, "窗帘", -1)
const _hoisted_206 = { class: "environmentMoreMenu" }
const _hoisted_207 = { class: "more_menu_title" }
const _hoisted_208 = { class: "icon" }
const _hoisted_209 = { class: "more_menu_content" }
const _hoisted_210 = {
  key: 0,
  class: "environmentData_item"
}
const _hoisted_211 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_Temperature",
  style: {"color":"rgb(206, 93, 98)"}
}, null, -1)
const _hoisted_212 = {
  key: 1,
  class: "environmentData_item"
}
const _hoisted_213 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_Humidity",
  style: {"color":"#409eff"}
}, null, -1)
const _hoisted_214 = {
  key: 2,
  class: "environmentData_item"
}
const _hoisted_215 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_PM25",
  style: {"color":"#5ccb3e"}
}, null, -1)
const _hoisted_216 = {
  key: 3,
  class: "environmentData_item"
}
const _hoisted_217 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_Co2",
  style: {"color":"#22d9b8"}
}, null, -1)
const _hoisted_218 = {
  key: 4,
  class: "environmentData_item"
}
const _hoisted_219 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_LUX",
  style: {"color":"rgb(232, 143, 24)"}
}, null, -1)
const _hoisted_220 = {
  key: 5,
  class: "environmentData_item"
}
const _hoisted_221 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_TVOC",
  style: {"color":"#de7bd4"}
}, null, -1)
const _hoisted_222 = {
  key: 6,
  class: "environmentData_item"
}
const _hoisted_223 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_PM10",
  style: {"color":"#b754d3"}
}, null, -1)
const _hoisted_224 = {
  key: 7,
  class: "environmentData_item"
}
const _hoisted_225 = /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon_CH2O",
  style: {"color":"#ff7c48"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_head_top = _resolveComponent("head-top")!
  const _component_my_player = _resolveComponent("my-player")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_head_top, {
      title: $data.className,
      assignURL: '/classroom/list'
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      ($data.CurVideoUrl)
        ? (_openBlock(), _createBlock(_component_my_player, {
            key: 0,
            class: "video-player",
            ref: "myPlayer",
            playPath: $data.CurVideoUrl
          }, null, 8, ["playPath"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        ($data.curVideo.DeviceInfo && $data.curVideo.DeviceInfo.IP)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString($data.curVideo.DeviceInfo.IP), 1)
            ]))
          : _createCommentVNode("", true),
        ($data.curVideo && $data.curVideo.DeviceType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              ($data.curVideo.DeviceType == 4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString($data.curVideo.DeviceInfo.Site == "1" ? "学生" : "老师") + "摄像头", 1))
                : _createCommentVNode("", true),
              ($data.curVideo.DeviceType == 5)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "课件摄像头"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        ($data.CampusesName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", null, _toDisplayString($data.CampusesName), 1)
            ]))
          : _createCommentVNode("", true),
        ($data.BuildingName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", null, _toDisplayString($data.BuildingName), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("span", null, _toDisplayString($data.className), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        ($data.Videos.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_22))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Videos, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item", index === $data.sourceActive ? 'active' : '']),
              key: index,
              onClick: ($event: any) => ($options.ChangeSource(index))
            }, _toDisplayString(item.DeviceType === "5"
                ? "课件"
                : item.DeviceType === "4"
                ? item.DeviceInfo.Site === "1"
                  ? "学生"
                  : "老师"
                : ""), 11, _hoisted_24))
          }), 128))
        ])
      ]),
      ($data.sensorInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
        : _createCommentVNode("", true),
      ($data.sensorInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", null, [
              _hoisted_30,
              _createTextVNode(" 温度：" + _toDisplayString($data.sensorInfo.tem.value) + "℃ ", 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_31,
              _createTextVNode(" 湿度：" + _toDisplayString($data.sensorInfo.hum.value) + "% ", 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (
          $setup.IOTCounts.filter((item) => {
            return item.total > 0;
          }).length
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
        : _createCommentVNode("", true),
      ($setup.IOTCounts.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            ($setup.IOTCounts[0].total)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["item", $setup.IOTCounts[0].using > 0 ? 'active' : ''])
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("i", {
                      class: _normalizeClass($setup.IOTCounts[0].icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[0].name), 1),
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[0].using) + "/" + _toDisplayString($setup.IOTCounts[0].total), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            ($setup.IOTCounts[1].total)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["item", $setup.IOTCounts[1].using > 0 ? 'active' : ''])
                }, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("i", {
                      class: _normalizeClass($setup.IOTCounts[1].icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[1].name), 1),
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[1].using) + "/" + _toDisplayString($setup.IOTCounts[1].total), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            ($setup.IOTCounts[2].total)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["item", $setup.IOTCounts[2].using > 0 ? 'active' : ''])
                }, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("i", {
                      class: _normalizeClass($setup.IOTCounts[2].icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[2].name), 1),
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[2].using) + "/" + _toDisplayString($setup.IOTCounts[2].total), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            ($setup.IOTCounts[3].total)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  class: _normalizeClass(["item", $setup.IOTCounts[3].using > 0 ? 'active' : ''])
                }, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("i", {
                      class: _normalizeClass($setup.IOTCounts[3].icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[3].name), 1),
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[3].using) + "/" + _toDisplayString($setup.IOTCounts[3].total), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            ($setup.IOTCounts[4].total)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 4,
                  class: _normalizeClass(["item", $setup.IOTCounts[4].using > 0 ? 'active' : ''])
                }, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("i", {
                      class: _normalizeClass($setup.IOTCounts[4].icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[4].name), 1),
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[4].using) + "/" + _toDisplayString($setup.IOTCounts[4].total), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            ($setup.IOTCounts[5].total)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 5,
                  class: _normalizeClass(["item", $setup.IOTCounts[5].using > 0 ? 'active' : ''])
                }, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("i", {
                      class: _normalizeClass($setup.IOTCounts[5].icon)
                    }, null, 2)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[5].name), 1),
                    _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[5].using) + "/" + _toDisplayString($setup.IOTCounts[5].total), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", {
          class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.State === 3 ||
                $data.TerminalInfo.Info.State === 'Opened'),
            ing:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.State === 2 ||
                $data.TerminalInfo.Info.State === 'Opening'),
            unActive:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.State === 0 ||
                $data.TerminalInfo.Info.State === 'Shutdown'),
          }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.Control('sceneOnClass', '')))
        }, _hoisted_53, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item", {
            ing:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.State === 1 ||
                $data.TerminalInfo.Info.State === 'ShuttingDown'),
          }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.Control('sceneOffClass', '')))
        }, _hoisted_56, 2),
        (
            $data.TerminalInfo && $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ'
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.Guard === 1 ||
                $data.TerminalInfo.Info.Guard === 'On'),
          }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.Control('Guard', $data.TerminalInfo.Info.Guard ? 0 : 1)))
            }, _hoisted_59, 2))
          : _createCommentVNode("", true),
        (
            $data.TerminalInfo &&
            ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ' ||
              $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600BG')
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.PanelLock === 1 ||
                $data.TerminalInfo.Info.PanelLock === 'On'),
          }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)))
            }, _hoisted_62, 2))
          : _createCommentVNode("", true),
        (
            $data.TerminalInfo && $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ'
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.ELock === 1 ||
                $data.TerminalInfo.Info.ELock === 'On'),
          }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.Control('E_Lock', $data.TerminalInfo.Info.ELock ? 0 : 1)))
            }, _hoisted_65, 2))
          : _createCommentVNode("", true),
        (
            $data.TerminalInfo && $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ'
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              ($data.TerminalInfo.Info.Arming === 1 ||
                $data.TerminalInfo.Info.Arming === 'On'),
          }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.Control('Arming', $data.TerminalInfo.Info.Arming ? 0 : 1)))
            }, _hoisted_68, 2))
          : _createCommentVNode("", true),
        (
            $data.TerminalInfo &&
            ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600QH' ||
              $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3000QH' ||
              $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ' ||
              $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600BG')
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 4,
              class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              $data.TerminalInfo.Info.Projectors &&
              $data.TerminalInfo.Info.Projectors[0].State &&
              ($data.TerminalInfo.Info.Projectors[0].State === 1 ||
                $data.TerminalInfo.Info.Projectors[0].State === 'On'),
          }]),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (
            $options.Control(
              'projectorer1',
              $data.TerminalInfo.Info &&
                $data.TerminalInfo.Info.Projectors &&
                $data.TerminalInfo.Info.Projectors[0].State
                ? 0
                : 1
            )
          ))
            }, _hoisted_71, 2))
          : _createCommentVNode("", true),
        (
            $data.TerminalInfo &&
            ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600QH' ||
              $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3000QH' ||
              $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ')
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 5,
              class: _normalizeClass(["item", {
            active:
              $data.TerminalInfo &&
              $data.TerminalInfo.Info &&
              $data.TerminalInfo.Info.Projectors &&
              $data.TerminalInfo.Info.Projectors[1].State &&
              ($data.TerminalInfo.Info.Projectors[1].State === 1 ||
                $data.TerminalInfo.Info.Projectors[1].State === 'On'),
          }]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (
            $options.Control(
              'projectorer2',
              $data.TerminalInfo.Info &&
                $data.TerminalInfo.Info.Projectors &&
                $data.TerminalInfo.Info.Projectors[1].State
                ? 0
                : 1
            )
          ))
            }, _hoisted_74, 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", {
          class: "next-bot",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($options.linkTo && $options.linkTo(...args)))
        }, _hoisted_77)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: $data.terminalMoreShow,
      "onUpdate:show": _cache[96] || (_cache[96] = ($event: any) => (($data.terminalMoreShow) = $event)),
      class: "terminalMorePopup",
      position: "bottom",
      overlay: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", null, [
              (
                $data.TerminalInfo.DeviceInfo.BrandCode === 'JYD' ||
                $data.TerminalInfo.DeviceInfo.BrandCode === 'ECHOR'
              )
                ? (_openBlock(), _createBlock(_component_van_icon, {
                    key: 0,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($data.terminalMoreShow = false)),
                    name: "replay"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_van_icon, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($data.terminalMoreShow = false)),
                name: "cross"
              })
            ])
          ]),
          (
            $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600QH' ||
            $data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3000QH'
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 3 ||
                      $data.TerminalInfo.Info.State === 'Opened'),
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 2 ||
                      $data.TerminalInfo.Info.State === 'Opening'),
                  unActive:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 0 ||
                      $data.TerminalInfo.Info.State === 'Shutdown'),
                }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.Control('sceneOnClass')))
                    }, " 上课 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 1 ||
                      $data.TerminalInfo.Info.State === 'ShuttingDown'),
                }]),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.Control('sceneOffClass')))
                    }, " 下课 ", 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _hoisted_86,
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.PanelLock === 1 ||
                      $data.TerminalInfo.Info.PanelLock === 'On'),
                }]),
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (
                  $options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)
                ))
                    }, " 面板锁 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.ELock === 1 ||
                      $data.TerminalInfo.Info.ELock === 'On'),
                }]),
                      onClick: _cache[14] || (_cache[14] = ($event: any) => ($options.Control('E_Lock', $data.TerminalInfo.Info.ELock ? 0 : 1)))
                    }, " 讲台锁 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.Arming === 1 ||
                      $data.TerminalInfo.Info.Arming === 'On'),
                }]),
                      onClick: _cache[15] || (_cache[15] = ($event: any) => ($options.Control('Arming', $data.TerminalInfo.Info.Arming ? 0 : 1)))
                    }, " 终端报警 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.Guard === 1 ||
                      $data.TerminalInfo.Info.Guard === 'On'),
                }]),
                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($options.Control('Guard', $data.TerminalInfo.Info.Guard ? 0 : 1)))
                    }, " 门禁 ", 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("div", _hoisted_90, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 ||
                      $data.TerminalInfo.Info.Projectors[0].State === 'On'),
                }]),
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (
                  $options.Control(
                    'projectorer1',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.Projectors &&
                      $data.TerminalInfo.Info.Projectors[0].State
                      ? 0
                      : 1
                  )
                ))
                    }, " 投影仪一 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[1].State &&
                    ($data.TerminalInfo.Info.Projectors[1].State === 1 ||
                      $data.TerminalInfo.Info.Projectors[1].State === 'On'),
                }]),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (
                  $options.Control(
                    'projectorer2',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.Projectors &&
                      $data.TerminalInfo.Info.Projectors[1].State
                      ? 0
                      : 1
                  )
                ))
                    }, " 投影仪二 ", 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _hoisted_92,
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoIns &&
                    $data.TerminalInfo.Info.VideoIns[0] &&
                    ($data.TerminalInfo.Info.VideoIns[0] === 1 ||
                      $data.TerminalInfo.Info.VideoIns[0] === 'On'),
                }]),
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (
                  $options.Control(
                    'Video_0',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoIns &&
                      $data.TerminalInfo.Info.VideoIns[0]
                      ? 0
                      : 1
                  )
                ))
                    }, " 睿课终端 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoIns &&
                    $data.TerminalInfo.Info.VideoIns[1] &&
                    ($data.TerminalInfo.Info.VideoIns[1] === 1 ||
                      $data.TerminalInfo.Info.VideoIns[1] === 'On'),
                }]),
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (
                  $options.Control(
                    'Video_1',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoIns &&
                      $data.TerminalInfo.Info.VideoIns[1]
                      ? 0
                      : 1
                  )
                ))
                    }, " VGA ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoIns &&
                    $data.TerminalInfo.Info.VideoIns[2] &&
                    ($data.TerminalInfo.Info.VideoIns[2] === 1 ||
                      $data.TerminalInfo.Info.VideoIns[2] === 'On'),
                }]),
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (
                  $options.Control(
                    'Video_2',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoIns &&
                      $data.TerminalInfo.Info.VideoIns[2]
                      ? 0
                      : 1
                  )
                ))
                    }, " 电脑 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoIns &&
                    $data.TerminalInfo.Info.VideoIns[3] &&
                    ($data.TerminalInfo.Info.VideoIns[3] === 1 ||
                      $data.TerminalInfo.Info.VideoIns[3] === 'On'),
                }]),
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (
                  $options.Control(
                    'Video_3',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoIns &&
                      $data.TerminalInfo.Info.VideoIns[3]
                      ? 0
                      : 1
                  )
                ))
                    }, " 笔记本 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoIns &&
                    $data.TerminalInfo.Info.VideoIns[4] &&
                    ($data.TerminalInfo.Info.VideoIns[4] === 1 ||
                      $data.TerminalInfo.Info.VideoIns[4] === 'On'),
                }]),
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (
                  $options.Control(
                    'Video_4',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoIns &&
                      $data.TerminalInfo.Info.VideoIns[4]
                      ? 0
                      : 1
                  )
                ))
                    }, " 网关 ", 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoIns &&
                    $data.TerminalInfo.Info.VideoIns[5] &&
                    ($data.TerminalInfo.Info.VideoIns[5] === 1 ||
                      $data.TerminalInfo.Info.VideoIns[5] === 'On'),
                }]),
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (
                  $options.Control(
                    'Video_5',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoIns &&
                      $data.TerminalInfo.Info.VideoIns[5]
                      ? 0
                      : 1
                  )
                ))
                    }, " 扩展 ", 2)
                  ])
                ]),
                ($data.Powers.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _hoisted_95,
                      _createElementVNode("div", _hoisted_96, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Powers, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["category_item", { active: item.Value === 'On' || item.Value === 1 }]),
                            key: index,
                            onClick: 
                  () =>
                    item.ID === 11 ||
                    item.ID === 23 ||
                    item.ID === 24 ||
                    item.ID === 53 ||
                    item.ID === 54
                      ? null
                      : $options.Control(`Power_${item.ID}`, item.Value ? 0 : 1)
                
                          }, _toDisplayString(item.Name), 11, _hoisted_97))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600JZ')
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _hoisted_100,
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 3 ||
                      $data.TerminalInfo.Info.State === 'Opened'),
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 2 ||
                      $data.TerminalInfo.Info.State === 'Opening'),
                  unActive:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 0 ||
                      $data.TerminalInfo.Info.State === 'Shutdown'),
                }]),
                        onClick: _cache[25] || (_cache[25] = ($event: any) => ($options.Control('sceneOnClass')))
                      }, " 上课 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 1 ||
                      $data.TerminalInfo.Info.State === 'ShuttingDown'),
                }]),
                        onClick: _cache[26] || (_cache[26] = ($event: any) => ($options.Control('sceneOffClass')))
                      }, " 下课 ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _hoisted_103,
                    _createElementVNode("div", _hoisted_104, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.PanelLock === 1 ||
                      $data.TerminalInfo.Info.PanelLock === 'On'),
                }]),
                        onClick: _cache[27] || (_cache[27] = ($event: any) => (
                  $options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)
                ))
                      }, " 面板锁 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.ELock === 1 ||
                      $data.TerminalInfo.Info.ELock === 'On'),
                }]),
                        onClick: _cache[28] || (_cache[28] = ($event: any) => ($options.Control('E_Lock', $data.TerminalInfo.Info.ELock ? 0 : 1)))
                      }, " 讲台锁 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.Arming === 1 ||
                      $data.TerminalInfo.Info.Arming === 'On'),
                }]),
                        onClick: _cache[29] || (_cache[29] = ($event: any) => ($options.Control('Arming', $data.TerminalInfo.Info.Arming ? 0 : 1)))
                      }, " 终端报警 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.Guard === 1 ||
                      $data.TerminalInfo.Info.Guard === 'On'),
                }]),
                        onClick: _cache[30] || (_cache[30] = ($event: any) => ($options.Control('Guard', $data.TerminalInfo.Info.Guard ? 0 : 1)))
                      }, " 门禁 ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_105, [
                    _hoisted_106,
                    _createElementVNode("div", _hoisted_107, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 ||
                      $data.TerminalInfo.Info.Projectors[0].State === 'On'),
                }]),
                        onClick: _cache[31] || (_cache[31] = ($event: any) => (
                  $options.Control(
                    'projectorer1',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.Projectors &&
                      $data.TerminalInfo.Info.Projectors[0].State
                      ? 0
                      : 1
                  )
                ))
                      }, " 投影仪一 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[1].State &&
                    ($data.TerminalInfo.Info.Projectors[1].State === 1 ||
                      $data.TerminalInfo.Info.Projectors[1].State === 'On'),
                }]),
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (
                  $options.Control(
                    'projectorer2',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.Projectors &&
                      $data.TerminalInfo.Info.Projectors[1].State
                      ? 0
                      : 1
                  )
                ))
                      }, " 投影仪二 ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 0,
                }]),
                        onClick: _cache[33] || (_cache[33] = ($event: any) => ($options.Control(`VI_0`)))
                      }, " 睿课终端-主 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 1,
                }]),
                        onClick: _cache[34] || (_cache[34] = ($event: any) => ($options.Control(`VI_1`)))
                      }, " 睿课终端-副 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 2,
                }]),
                        onClick: _cache[35] || (_cache[35] = ($event: any) => ($options.Control(`VI_2`)))
                      }, " 台式机HDMI ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 3,
                }]),
                        onClick: _cache[36] || (_cache[36] = ($event: any) => ($options.Control(`VI_3`)))
                      }, " 台式机VGA ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 4,
                }]),
                        onClick: _cache[37] || (_cache[37] = ($event: any) => ($options.Control(`VI_4`)))
                      }, " 笔记本HDMI ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 5,
                }]),
                        onClick: _cache[38] || (_cache[38] = ($event: any) => ($options.Control(`VI_5`)))
                      }, " 笔记本VGA ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 6,
                }]),
                        onClick: _cache[39] || (_cache[39] = ($event: any) => ($options.Control(`VI_6`)))
                      }, " 扩展一 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info && $data.TerminalInfo.Info.VideoSource === 7,
                }]),
                        onClick: _cache[40] || (_cache[40] = ($event: any) => ($options.Control(`VI_7`)))
                      }, " 扩展二 ", 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _hoisted_112,
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", {
                        class: "category_item",
                        onClick: _cache[41] || (_cache[41] = ($event: any) => ($options.Control(`VO_ALL_${$data.TerminalInfo.Info.VideoSource}`)))
                      }, " 全部 "),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoSource ===
                      $data.TerminalInfo.Info.VideoOuts[0] &&
                    $data.TerminalInfo.Info.VideoOuts[0] !== 100,
                }]),
                        onClick: _cache[42] || (_cache[42] = ($event: any) => (
                  $options.Control(
                    `VO_23_${
                      $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoSource ===
                        $data.TerminalInfo.Info.VideoOuts[0]
                        ? 0
                        : 1
                    }`
                  )
                ))
                      }, " 大屏一 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoSource ===
                      $data.TerminalInfo.Info.VideoOuts[1] &&
                    $data.TerminalInfo.Info.VideoOuts[1] !== 100,
                }]),
                        onClick: _cache[43] || (_cache[43] = ($event: any) => (
                  $options.Control(
                    `VO_24_${
                      $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoSource ===
                        $data.TerminalInfo.Info.VideoOuts[1]
                        ? 0
                        : 1
                    }`
                  )
                ))
                      }, " 大屏二 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoSource ===
                      $data.TerminalInfo.Info.VideoOuts[2] &&
                    $data.TerminalInfo.Info.VideoOuts[2] !== 100,
                }]),
                        onClick: _cache[44] || (_cache[44] = ($event: any) => (
                  $options.Control(
                    `VO_25_${
                      $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoSource ===
                        $data.TerminalInfo.Info.VideoOuts[2]
                        ? 0
                        : 1
                    }`
                  )
                ))
                      }, " 显示器 ", 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.VideoSource ===
                      $data.TerminalInfo.Info.VideoOuts[3] &&
                    $data.TerminalInfo.Info.VideoOuts[3] !== 100,
                }]),
                        onClick: _cache[45] || (_cache[45] = ($event: any) => (
                  $options.Control(
                    `VO_26_${
                      $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.VideoSource ===
                        $data.TerminalInfo.Info.VideoOuts[3]
                        ? 0
                        : 1
                    }`
                  )
                ))
                      }, " 录播互动 ", 2)
                    ])
                  ]),
                  ($data.Powers.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                        _hoisted_115,
                        _createElementVNode("div", _hoisted_116, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Powers, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["category_item", { active: item.Value === 1 || item.Value === 'On' }]),
                              key: index,
                              onClick: 
                  () =>
                    item.ID === 11 ||
                    item.ID === 23 ||
                    item.ID === 24 ||
                    item.ID === 53 ||
                    item.ID === 54
                      ? null
                      : $options.Control(`Power_${item.ID}`, item.Value ? 0 : 1)
                
                            }, _toDisplayString(item.Name), 11, _hoisted_117))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : ($data.TerminalInfo.DeviceInfo.ModelCode === 'CPC3600BG')
                ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _createElementVNode("div", _hoisted_121, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 3 ||
                      $data.TerminalInfo.Info.State === 'Opened'),
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 2 ||
                      $data.TerminalInfo.Info.State === 'Opening'),
                  unActive:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 0 ||
                      $data.TerminalInfo.Info.State === 'Shutdown'),
                }]),
                          onClick: _cache[46] || (_cache[46] = ($event: any) => ($options.Control('sceneOnClass')))
                        }, " 上课 ", 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["category_item", {
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 1 ||
                      $data.TerminalInfo.Info.State === 'ShuttingDown'),
                }]),
                          onClick: _cache[47] || (_cache[47] = ($event: any) => ($options.Control('sceneOffClass')))
                        }, " 下课 ", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_122, [
                      _hoisted_123,
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.PanelLock === 1 ||
                      $data.TerminalInfo.Info.PanelLock === 'On'),
                }]),
                          onClick: _cache[48] || (_cache[48] = ($event: any) => (
                  $options.Control('PanelLock', $data.TerminalInfo.Info.PanelLock ? 0 : 1)
                ))
                        }, " 面板锁 ", 2)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_125, [
                      _hoisted_126,
                      _createElementVNode("div", _hoisted_127, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0].State &&
                    ($data.TerminalInfo.Info.Projectors[0].State === 1 ||
                      $data.TerminalInfo.Info.Projectors[0].State === 'On'),
                }]),
                          onClick: _cache[49] || (_cache[49] = ($event: any) => (
                  $options.Control(
                    'projectorer1',
                    $data.TerminalInfo.Info &&
                      $data.TerminalInfo.Info.Projectors &&
                      $data.TerminalInfo.Info.Projectors[0].State
                      ? 0
                      : 1
                  )
                ))
                        }, " 投影仪一 ", 2)
                      ])
                    ]),
                    ($data.Powers.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                          _hoisted_129,
                          _createElementVNode("div", _hoisted_130, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Powers, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["category_item", { active: item.Value === 1 || item.Value === 'On' }]),
                                key: index,
                                onClick: 
                  () =>
                    item.ID === 11 ||
                    item.ID === 23 ||
                    item.ID === 24 ||
                    item.ID === 53 ||
                    item.ID === 54
                      ? null
                      : $options.Control(`Power_${item.ID}`, item.Value ? 0 : 1)
                
                              }, _toDisplayString(item.Name), 11, _hoisted_131))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : ($data.TerminalInfo.DeviceInfo.BrandCode === 'JYD')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                      _createElementVNode("div", _hoisted_133, [
                        _hoisted_134,
                        _createElementVNode("div", _hoisted_135, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 3 ||
                      $data.TerminalInfo.Info.State === 'Opened'),
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 2 ||
                      $data.TerminalInfo.Info.State === 'Opening'),
                  unActive:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 0 ||
                      $data.TerminalInfo.Info.State === 'Shutdown'),
                }]),
                            onClick: _cache[50] || (_cache[50] = ($event: any) => ($options.Control('sceneOnClass')))
                          }, " 上课 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["category_item", {
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 1 ||
                      $data.TerminalInfo.Info.State === 'ShuttingDown'),
                }]),
                            onClick: _cache[51] || (_cache[51] = ($event: any) => ($options.Control('sceneOffClass')))
                          }, " 下课 ", 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_136, [
                        _hoisted_137,
                        _createElementVNode("div", _hoisted_138, [
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[52] || (_cache[52] = ($event: any) => ($options.Control('Control_UnLock')))
                          }, " 解锁中控 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[53] || (_cache[53] = ($event: any) => ($options.Control('Control_Lock')))
                          }, " 锁定中控 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[54] || (_cache[54] = ($event: any) => ($options.Control('E_UnLock')))
                          }, " 电子锁开 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[55] || (_cache[55] = ($event: any) => ($options.Control('E_Lock')))
                          }, " 电子锁关 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[56] || (_cache[56] = ($event: any) => ($options.Control('Control_Arming')))
                          }, " 报警布防 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[57] || (_cache[57] = ($event: any) => ($options.Control('Control_Disarmed')))
                          }, " 报警撤防 ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_139, [
                        _hoisted_140,
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[58] || (_cache[58] = ($event: any) => ($options.Control('ProjectorOpen')))
                          }, " 投影仪开 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[59] || (_cache[59] = ($event: any) => ($options.Control('ProjectorOff')))
                          }, " 投影仪关 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[60] || (_cache[60] = ($event: any) => ($options.Control('Projector_RGB')))
                          }, " RGB "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[61] || (_cache[61] = ($event: any) => ($options.Control('Projector_Video')))
                          }, " Video ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_142, [
                        _hoisted_143,
                        _createElementVNode("div", _hoisted_144, [
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[62] || (_cache[62] = ($event: any) => ($options.Control('Projector_PC')))
                          }, " 台式机 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[63] || (_cache[63] = ($event: any) => ($options.Control('Projector_Laptop')))
                          }, " 笔记本 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[64] || (_cache[64] = ($event: any) => ($options.Control('Projector_Booth')))
                          }, " 数字展台 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[65] || (_cache[65] = ($event: any) => ($options.Control('Projector_Gateway')))
                          }, " 互动网关 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[66] || (_cache[66] = ($event: any) => ($options.Control('Projector_Reserve')))
                          }, " 备用 ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_145, [
                        _hoisted_146,
                        _createElementVNode("div", _hoisted_147, [
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[67] || (_cache[67] = ($event: any) => ($options.Control('AVOut_VCR')))
                          }, " 录像机 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[68] || (_cache[68] = ($event: any) => ($options.Control('AVOut_DVD')))
                          }, "DVD"),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[69] || (_cache[69] = ($event: any) => ($options.Control('AVOut_Booth')))
                          }, " 实物展台 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[70] || (_cache[70] = ($event: any) => ($options.Control('AVOut_Control')))
                          }, " 中控 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[71] || (_cache[71] = ($event: any) => ($options.Control('AVOut_Speaker')))
                          }, " 话筒 "),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[72] || (_cache[72] = ($event: any) => ($options.Control('Projector_Reserve')))
                          }, " 备用 ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        _hoisted_149,
                        _createElementVNode("div", _hoisted_150, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.PowerInfos &&
                    $data.TerminalInfo.Info.PowerInfos[0] === 'On',
                }]),
                            onClick: _cache[73] || (_cache[73] = ($event: any) => ($options.Control('CurtainRose')))
                          }, " 升起 ", 2),
                          _createElementVNode("div", {
                            class: "category_item",
                            onClick: _cache[74] || (_cache[74] = ($event: any) => ($options.Control('CurtainStop')))
                          }, " 停止 "),
                          _createElementVNode("div", {
                            class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.PowerInfos &&
                    $data.TerminalInfo.Info.PowerInfos[0] === 'Off',
                }]),
                            onClick: _cache[75] || (_cache[75] = ($event: any) => ($options.Control('CurtainDown')))
                          }, " 降落 ", 2)
                        ])
                      ])
                    ]))
                  : ($data.TerminalInfo.DeviceInfo.BrandCode === 'ECHOR')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                        _createElementVNode("div", _hoisted_152, [
                          _hoisted_153,
                          _createElementVNode("div", _hoisted_154, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 3 ||
                      $data.TerminalInfo.Info.State === 'Opened'),
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 2 ||
                      $data.TerminalInfo.Info.State === 'Opening'),
                  unActive:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 0 ||
                      $data.TerminalInfo.Info.State === 'Shutdown'),
                }]),
                              onClick: _cache[76] || (_cache[76] = ($event: any) => ($options.Control('sceneOnClass')))
                            }, " 上课 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 1 ||
                      $data.TerminalInfo.Info.State === 'ShuttingDown'),
                }]),
                              onClick: _cache[77] || (_cache[77] = ($event: any) => ($options.Control('sceneOffClass')))
                            }, " 下课 ", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_155, [
                          _hoisted_156,
                          _createElementVNode("div", _hoisted_157, [
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[78] || (_cache[78] = ($event: any) => ($options.Control('E_UnLock')))
                            }, " 讲台锁开 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[79] || (_cache[79] = ($event: any) => ($options.Control('E_Lock')))
                            }, " 讲台锁关 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[80] || (_cache[80] = ($event: any) => ($options.Control('Control_UnLock')))
                            }, " 解锁面板 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[81] || (_cache[81] = ($event: any) => ($options.Control('Control_Lock')))
                            }, " 锁定面板 ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_158, [
                          _hoisted_159,
                          _createElementVNode("div", _hoisted_160, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.PowerInfos &&
                    $data.TerminalInfo.Info.PowerInfos[1] === 'On',
                }]),
                              onClick: _cache[82] || (_cache[82] = ($event: any) => ($options.Control('Power_PC_Open')))
                            }, " 开启电脑 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.PowerInfos &&
                    $data.TerminalInfo.Info.PowerInfos[1] === 'Off',
                }]),
                              onClick: _cache[83] || (_cache[83] = ($event: any) => ($options.Control('Power_PC_Off')))
                            }, " 关闭电脑 ", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_161, [
                          _hoisted_162,
                          _createElementVNode("div", _hoisted_163, [
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[84] || (_cache[84] = ($event: any) => ($options.Control('PS_Computer')))
                            }, " 电脑 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[85] || (_cache[85] = ($event: any) => ($options.Control('PS_Notepad')))
                            }, " 笔记本 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[86] || (_cache[86] = ($event: any) => ($options.Control('PS_Video3')))
                            }, " 视频三 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[87] || (_cache[87] = ($event: any) => ($options.Control('PS_Video4')))
                            }, " 视频四 ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_164, [
                          _hoisted_165,
                          _createElementVNode("div", _hoisted_166, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0] &&
                    $data.TerminalInfo.Info.Projectors[0] === 'On',
                }]),
                              onClick: _cache[88] || (_cache[88] = ($event: any) => ($options.Control('ProjectorOpen')))
                            }, " 投影仪开 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo.Info &&
                    $data.TerminalInfo.Info.Projectors &&
                    $data.TerminalInfo.Info.Projectors[0] &&
                    $data.TerminalInfo.Info.Projectors[0] === 'Off',
                }]),
                              onClick: _cache[89] || (_cache[89] = ($event: any) => ($options.Control('ProjectorOff')))
                            }, " 投影仪关 ", 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_167, [
                          _hoisted_168,
                          _createElementVNode("div", _hoisted_169, [
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[90] || (_cache[90] = ($event: any) => ($options.Control('CurtainRose')))
                            }, " 关投影幕 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[91] || (_cache[91] = ($event: any) => ($options.Control('CurtainDown')))
                            }, " 开投影幕 ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_170, [
                          _hoisted_171,
                          _createElementVNode("div", _hoisted_172, [
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[92] || (_cache[92] = ($event: any) => ($options.Control('PlusSoundVolume')))
                            }, " 音频加 "),
                            _createElementVNode("div", {
                              class: "category_item",
                              onClick: _cache[93] || (_cache[93] = ($event: any) => ($options.Control('MinusSoundVolume')))
                            }, " 音频减 ")
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_173, [
                        _createElementVNode("div", _hoisted_174, [
                          _hoisted_175,
                          _createElementVNode("div", _hoisted_176, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  active:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 3 ||
                      $data.TerminalInfo.Info.State === 'Opened'),
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 2 ||
                      $data.TerminalInfo.Info.State === 'Opening'),
                  unActive:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 0 ||
                      $data.TerminalInfo.Info.State === 'Shutdown'),
                }]),
                              onClick: _cache[94] || (_cache[94] = ($event: any) => ($options.Control('sceneOnClass')))
                            }, " 上课 ", 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["category_item", {
                  ing:
                    $data.TerminalInfo &&
                    $data.TerminalInfo.Info &&
                    ($data.TerminalInfo.Info.State === 1 ||
                      $data.TerminalInfo.Info.State === 'ShuttingDown'),
                }]),
                              onClick: _cache[95] || (_cache[95] = ($event: any) => ($options.Control('sceneOffClass')))
                            }, " 下课 ", 2)
                          ])
                        ])
                      ]))
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: $data.internetMoreShow,
      "onUpdate:show": _cache[110] || (_cache[110] = ($event: any) => (($data.internetMoreShow) = $event)),
      class: "internetMorePopup",
      position: "bottom",
      overlay: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_177, [
          _createElementVNode("div", _hoisted_178, [
            _hoisted_179,
            _createElementVNode("div", _hoisted_180, [
              _createVNode(_component_van_icon, { name: "replay" }),
              _createVNode(_component_van_icon, {
                onClick: _cache[97] || (_cache[97] = ($event: any) => ($data.internetMoreShow = false)),
                name: "cross"
              })
            ])
          ]),
          ($setup.IOTCounts.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                ($setup.IOTCounts[0].total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["terminal_name", $setup.IOTCounts[0].using > 0 ? 'active' : ''])
                      }, [
                        _hoisted_183,
                        _createElementVNode("div", _hoisted_184, [
                          _hoisted_185,
                          _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[0].using) + "/" + _toDisplayString($setup.IOTCounts[0].total), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[98] || (_cache[98] = ($event: any) => ($options.batchAirSwitch(true)))
                      }, " 断路器全开 "),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[99] || (_cache[99] = ($event: any) => ($options.batchAirSwitch(false)))
                      }, " 断路器全关 ")
                    ]))
                  : _createCommentVNode("", true),
                ($setup.IOTCounts[1].total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["terminal_name", $setup.IOTCounts[1].using > 0 ? 'active' : ''])
                      }, [
                        _hoisted_187,
                        _createElementVNode("div", _hoisted_188, [
                          _hoisted_189,
                          _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[1].using) + "/" + _toDisplayString($setup.IOTCounts[1].total), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[100] || (_cache[100] = ($event: any) => ($options.batchIoTLS(false)))
                      }, " 面板全开 "),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[101] || (_cache[101] = ($event: any) => ($options.batchIoTLS(true)))
                      }, " 面板全关 ")
                    ]))
                  : _createCommentVNode("", true),
                ($setup.IOTCounts[2].total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["terminal_name", $setup.IOTCounts[2].using > 0 ? 'active' : ''])
                      }, [
                        _hoisted_191,
                        _createElementVNode("div", _hoisted_192, [
                          _hoisted_193,
                          _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[2].using) + "/" + _toDisplayString($setup.IOTCounts[2].total), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[102] || (_cache[102] = ($event: any) => ($options.batchDim('w')))
                      }, "全部白光"),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[103] || (_cache[103] = ($event: any) => ($options.batchDim('y')))
                      }, "全部黄光")
                    ]))
                  : _createCommentVNode("", true),
                ($setup.IOTCounts[3].total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_194, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["terminal_name", $setup.IOTCounts[3].using > 0 ? 'active' : ''])
                      }, [
                        _hoisted_195,
                        _createElementVNode("div", _hoisted_196, [
                          _hoisted_197,
                          _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[3].using) + "/" + _toDisplayString($setup.IOTCounts[3].total), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[104] || (_cache[104] = ($event: any) => ($options.batchAir(1)))
                      }, "空调全开"),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[105] || (_cache[105] = ($event: any) => ($options.batchAir(0)))
                      }, "空调全关")
                    ]))
                  : _createCommentVNode("", true),
                ($setup.IOTCounts[4].total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["terminal_name", $setup.IOTCounts[4].using > 0 ? 'active' : ''])
                      }, [
                        _hoisted_199,
                        _createElementVNode("div", _hoisted_200, [
                          _hoisted_201,
                          _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[4].using) + "/" + _toDisplayString($setup.IOTCounts[4].total), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[106] || (_cache[106] = ($event: any) => ($options.batchFS(5)))
                      }, "风扇全开"),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[107] || (_cache[107] = ($event: any) => ($options.batchFS(0)))
                      }, "风扇全关")
                    ]))
                  : _createCommentVNode("", true),
                ($setup.IOTCounts[5].total)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["terminal_name", $setup.IOTCounts[5].using > 0 ? 'active' : ''])
                      }, [
                        _hoisted_203,
                        _createElementVNode("div", _hoisted_204, [
                          _hoisted_205,
                          _createElementVNode("div", null, _toDisplayString($setup.IOTCounts[5].using) + "/" + _toDisplayString($setup.IOTCounts[5].total), 1)
                        ])
                      ], 2),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[108] || (_cache[108] = ($event: any) => ($options.batchCL(0)))
                      }, "窗帘全开"),
                      _createElementVNode("div", {
                        class: "terminal_control",
                        onClick: _cache[109] || (_cache[109] = ($event: any) => ($options.batchCL(1)))
                      }, "窗帘全关")
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: $data.environmentMoreShow,
      "onUpdate:show": _cache[112] || (_cache[112] = ($event: any) => (($data.environmentMoreShow) = $event)),
      class: "environmentMoreShowMorePopup",
      position: "bottom",
      overlay: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_206, [
          _createElementVNode("div", _hoisted_207, [
            _createElementVNode("div", null, _toDisplayString($data.className), 1),
            _createElementVNode("div", _hoisted_208, [
              _createVNode(_component_van_icon, {
                onClick: _cache[111] || (_cache[111] = ($event: any) => ($data.environmentMoreShow = false)),
                name: "cross"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_209, [
            ($data.sensorInfo.tem)
              ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                  _hoisted_211,
                  _createTextVNode(" 温度:" + _toDisplayString($data.sensorInfo.tem.value) + "℃ ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.hum)
              ? (_openBlock(), _createElementBlock("div", _hoisted_212, [
                  _hoisted_213,
                  _createTextVNode(" 湿度:" + _toDisplayString($data.sensorInfo.hum.value) + "% ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.pm25)
              ? (_openBlock(), _createElementBlock("div", _hoisted_214, [
                  _hoisted_215,
                  _createTextVNode(" PM2.5:" + _toDisplayString($data.sensorInfo.pm25.value) + "μg/m3 ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.co)
              ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
                  _hoisted_217,
                  _createTextVNode(" CO2:" + _toDisplayString($data.sensorInfo.co.value) + "PPM ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.lux)
              ? (_openBlock(), _createElementBlock("div", _hoisted_218, [
                  _hoisted_219,
                  _createTextVNode(" 光照度:" + _toDisplayString($data.sensorInfo.lux.value) + "LUX ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.tvoc)
              ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                  _hoisted_221,
                  _createTextVNode(" TVOC:" + _toDisplayString($data.sensorInfo.tvoc.value) + "μg/m3 ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.pm10)
              ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                  _hoisted_223,
                  _createTextVNode(" PM10:" + _toDisplayString($data.sensorInfo.pm10.value) + "μg/m3 ", 1)
                ]))
              : _createCommentVNode("", true),
            ($data.sensorInfo.ch20)
              ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                  _hoisted_225,
                  _createTextVNode(" 甲醛:" + _toDisplayString($data.sensorInfo.ch20.value) + "μg/m3 ", 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}